import { useState, useEffect } from "react";
import { createColumnsMaterialTable } from "../../../../utils/helpers/ColumnsDashboardMaterialTable";
import { StafSekreService } from "../../../../services/Integration/staf-sekre/StafSekreService";
import MaterialTable from "material-table";
import DOSEN_ROLES from "../../../../utils/constants/DosenRoles.constants";
import DashboardDetailPanel from "../../../../utils/helpers/DashboardDetailPanel";

export default function DashboardAdminTable({
  statusTindakan,
  term,
  tipe = null,
}) {
  const [isLoading, setIsLoading] = useState({ form: false, submit: false });
  const [mKSpesials, setMKSpesials] = useState([]);

  useEffect(() => {
    refreshData();
  }, [term]);

  const refreshData = async () => {
    setIsLoading({ ...isLoading, form: true });
    await getMKSpesialByStatusTindakanAndTermAndTipe();
    setIsLoading({ ...isLoading, form: false });
  };

  const getMKSpesialByStatusTindakanAndTermAndTipe = async () => {
    await StafSekreService.getDashboardStafSekre(
      statusTindakan,
      term.id_term,
      tipe
    )
      .then((response) => {
        if (response.status === 200) {
          setMKSpesials(response.data);
        } else {
          console.log(response);
        }
      })
      .catch((error) => console.log(error));
  };

  return (
    <MaterialTable
      style={{ fontSize: 14 }}
      isLoading={isLoading.form}
      title={<span className="text-lg">Daftar Sidang Mahasiswa</span>}
      data={mKSpesials}
      columns={createColumnsMaterialTable(true)}
      detailPanel={(rowData) => (
        // mendapat akses layaknya penguji
        <DashboardDetailPanel
          rowData={rowData}
          dosenRole={DOSEN_ROLES.penguji}
          term={term}
          sekreRole={true}
        />
      )}
      onRowClick={(event, rowData, togglePanel) => togglePanel()}
      actions={[
        {
          icon: "refresh",
          tooltip: "Refresh Data",
          isFreeAction: true,
          onClick: () => {
            refreshData();
          },
        },
      ]}
      options={{
        actionsColumnIndex: -1,
        sorting: true,
        search: true,
        filtering: true,
        grouping: false,
        pageSize: 10,
      }}
    />
  );
}
